module.exports = __webpack_public_path__ + "img/back2.1527148d.jpg";